import type { AssistantTask } from '@accounting/shared';
import { PROVIDER_LABELS } from '../../hooks/useAssistant';

export function dueLabel(dueDate: string | null, today: string): { text: string; tone: 'overdue' | 'today' | 'later' | 'none' } {
  if (!dueDate) return { text: '', tone: 'none' };
  if (dueDate < today) return { text: `overdue · ${dueDate}`, tone: 'overdue' };
  if (dueDate === today) return { text: 'today', tone: 'today' };
  return { text: dueDate, tone: 'later' };
}

export function TaskRow({
  task,
  today,
  busy,
  onToggle,
  onEdit,
  onDelete,
}: {
  task: AssistantTask;
  today: string;
  busy?: boolean;
  onToggle: (task: AssistantTask) => void;
  onEdit: (task: AssistantTask) => void;
  onDelete: (task: AssistantTask) => void;
}) {
  const due = dueLabel(task.dueDate, today);
  const done = task.status === 'completed';
  return (
    <div className={`pa-task${done ? ' pa-task--done' : ''}`}>
      <input
        type="checkbox"
        checked={done}
        disabled={busy || !task.canWrite}
        onChange={() => onToggle(task)}
        aria-label={done ? `Reopen ${task.title}` : `Complete ${task.title}`}
      />
      <span className="pa-dot" style={{ background: task.color }} aria-hidden="true" />
      <button type="button" className="pa-task__title" onClick={() => onEdit(task)} title={task.notes ?? undefined}>
        {task.priority === 'high' && <span className="pa-task__prio" title="High priority">!</span>}
        {task.title || '(untitled)'}
      </button>
      {due.tone !== 'none' && <span className={`tag pa-due pa-due--${due.tone}`}>{due.text}</span>}
      {task.matterRef && <span className="tag">{task.matterRef}</span>}
      <span className="muted pa-task__source">
        {task.provider === 'native' ? 'Assistant' : `${PROVIDER_LABELS[task.provider] ?? task.provider}${task.listName ? ` · ${task.listName}` : ''}`}
        {task.pendingSync ? ' · syncing' : ''}
      </span>
      {task.canWrite && (
        <button type="button" className="link-button pa-task__delete" onClick={() => onDelete(task)} aria-label={`Delete ${task.title}`} disabled={busy}>
          ✕
        </button>
      )}
    </div>
  );
}
